import script from "./ViewViolation.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewViolation.vue?vue&type=script&setup=true&lang=js"

import "./ViewViolation.vue?vue&type=style&index=0&id=e61eeae8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e61eeae8"]])

export default __exports__